import * as THREE from 'three';
const MIN_LENGTH = 1e-6;
export function resolveProfilePlacement(from, to, lateral) {
    const start = new THREE.Vector3(...from);
    const end = new THREE.Vector3(...to);
    const tangent = end.clone().sub(start);
    const length = tangent.length();
    if (!Number.isFinite(length) || length < MIN_LENGTH)
        return null;
    tangent.divideScalar(length);
    const width = new THREE.Vector3(...lateral).addScaledVector(tangent, -new THREE.Vector3(...lateral).dot(tangent));
    if (!Number.isFinite(width.lengthSq()) || width.lengthSq() < MIN_LENGTH * MIN_LENGTH)
        return null;
    width.normalize();
    const normal = new THREE.Vector3().crossVectors(width, tangent).normalize();
    const rotation = new THREE.Matrix4().makeBasis(width, tangent, normal);
    const center = start.add(end).multiplyScalar(0.5);
    return {
        position: [center.x, center.y, center.z],
        quaternion: new THREE.Quaternion().setFromRotationMatrix(rotation),
        length,
    };
}
